import { render, staticRenderFns } from "./PaymentPixDenied.vue?vue&type=template&id=8be76514&scoped=true"
import script from "./PaymentPixDenied.vue?vue&type=script&lang=js"
export * from "./PaymentPixDenied.vue?vue&type=script&lang=js"
import style0 from "./PaymentPixDenied.vue?vue&type=style&index=0&id=8be76514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be76514",
  null
  
)

export default component.exports